import PCRichTextEditor from './pc';
import MobileRichTextEditor from './mobile';

export { PCRichTextEditor, MobileRichTextEditor };
